function cart_gift(){
  var elements = document.querySelectorAll('.product_handle');
  var searchText = 'big-night-gift-box';
  var count = 0;
  const cartTitles = document.querySelectorAll('.cart span.name');

              // Loop through each element and replace &#39; with '
              cartTitles.forEach(cartTitle => {
                cartTitle.textContent = cartTitle.textContent.replace(/&#39;/g, "'");
              });
elements.forEach(function(element) {
    if (element.innerText.includes(searchText)) {
       var text_desc = $('.gift_form_group input[type=checkbox]').attr('data-desc');
      if(text_desc != ''){
        $(element).parents('.cart-desc').find('.custom-desc').remove();
        $(element).after('<div class="custom-desc">' + text_desc + '</div>');
      }
      count++;
    }else{
      $(element).parents('.cart-desc').find('.custom-desc').remove();
    }
  });
  // var elements_gift = document.querySelector('.gift_label');
  // if(count > 0 ){
  //   elements_gift.style.display = 'none';
  // }else{
  //   elements_gift.style.display = 'block';
  //     var cartNote = document.getElementById('CartSpecialInstructions');
  //     if (cartNote) {
  //       // cartNote.value = '';
  //     }
  // }
  $(".new_menu_list_wpr li, .new_menu_list_wpr a[data-img]").on({
    mouseenter: function () {
        var anchor = $(this).is("li") ? $(this).find('a[data-img]') : $(this);

        if (!anchor) return;
        var mainMenuImage = anchor.parents('.new_megamenu_main').find('.new_megamenu_img');
        if (!mainMenuImage) return;
        mainMenuImage.find('img').attr('src',anchor.data('img'));
    },
    mouseleave: function () {
        console.log('anchor hover off');
        var anchor = $(this).is("li") ? $(this).find('a[data-img]') : $(this);
        if (!anchor) return;
        var mainMenuImage = anchor.parents('.new_megamenu_main').find('.new_megamenu_img');
        if (!mainMenuImage) return;
        mainMenuImage.find('img').attr('src',mainMenuImage.data('img'));
    }
});

  $('.productsInCart').each(function(i, v) {
    var product_cart = $(this).find('[rv-href="item.url | escape"]');
    var product_cart_val = product_cart.attr('href');

    $.ajax({
        type: 'GET',
        url: product_cart_val,
        success: function(response) {
          if($(response).find('c#prodesc .price-sale').length > 0){
            if(product_cart.parents('.productsInCart').find('del').text()){
            }else{      
                var peice_com = $(response).find('c#prodesc .price-regular').text();
                product_cart.parents('.productsInCart').find('del').text(peice_com).show();
            }
          }else{
             product_cart.parents('.productsInCart').find('del').text('').hide();
          }
        },
        error: function(error) {
            console.log("Error:", error);
        }
    });
});
  
    $('.productsInCart').each(function(i, v) {
    var product_cart = $(this).find('.product_handle');
    var product_cart_val = product_cart.text().trim();

    $.ajax({
        type: 'GET',
        url: 'https://bignightbk.com/products/' + encodeURIComponent(product_cart_val) + '?view=meta-val',
        success: function(response) {
          // var find_meta = $(response).find('.meta_val_product').text();
            if (/sale/i.test(response)) {
                product_cart.parents('.productsInCart').addClass('cart_sale');
            }else{
              product_cart.parents('.productsInCart').removeClass('cart_sale');
            }
        },
        error: function(error) {
            console.log("Error:", error);
        }
    });
});

}

// Cookies
function createCookie(cookieName,cookieValue,daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
}

function accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for(var i=0; i<allCookieArray.length; i++) {
        var temp = allCookieArray[i].trim();
        if (temp.indexOf(name)==0)
        return temp.substring(name.length,temp.length);
    }
    return "";
}

function setCookieCloseBox(cookieName) {
    createCookie(cookieNaam, 'closed', days); // create cookie 
    document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
    document.body.classList.remove('newsletterbox-active'); // hide newsletter box
}

// Newsletter
function newsletterPopup() {
    var newsletterBox = document.getElementById("newsletterbox");
    if (newsletterBox) {
        var cookieNaam = "newspopup";
        var isCookie = accessCookie(cookieNaam);

        var days = newsletterBox.dataset.expire; // Get days from data-expire
        var cdown = newsletterBox.dataset.cdown; // Get count down from data-cdown
        var tnx = newsletterBox.dataset.thanks; // Get thanks from data-tnx
        var err = newsletterBox.dataset.err; // Get error from data-err
        var mail = newsletterBox.dataset.mail; // Get mail from data-mail

        if (days === undefined) { var days = 7; }
        if (cdown === undefined) { var cdown = 30000; }
        if (tnx === undefined) { var tnx = "Thanks for signing up!"; }
        if (err === undefined) { var err = "There was an error in submitting the form."; }
        if (mail === undefined) { var mail = "Please fill in your email address."; }

        // Countdown: show after X sec
        function countDownr(event) {
            setTimeout(function() {
                document.body.classList.add('newsletter-active'); // show newsletter box
            }, cdown);
        }

        // Check if user tries to leave from top
        function userLeave(event) {
            if(event.clientY <= 0) {
                document.body.classList.add('newsletter-active'); // show newsletter box
            }
        }

        // If cookie is not set show newsletter box
        if(isCookie !== 'closed') {
            countDownr(); // start countdown
        }

        // If is challenge page
        var challengeUrl = window.location.origin +'/challenge#contact_form';
        var currentUrl = window.location;
        if(currentUrl == challengeUrl) {
            document.getElementById('newsletterbox').style.display = 'none';
        }

        // Set cookie for "X" days and close newsletter box
        function setCookieNclose() {
            createCookie(cookieNaam, 'closed', days); // create cookie 
            document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
            document.body.classList.remove('newsletter-active'); // hide newsletter box
        }

        // On click Set cookie for "X" days and close newsletter box
        document.getElementById('closenewsletter').addEventListener("click", function() {
            setCookieNclose();
        });

        // Newsletter submit thru AJAX
        // TODO: convert in Vanilla JS
        $('form.contact-form').submit( function(){
            $('p.msg.is-green, p.msg.is-red').remove();
            if($(this).find('input[type="email"]').val() !== '') {
                var data = $(this).serialize();
                $.ajax({
                    type: "POST",
                    url: "/contact#contact_form",
                    data: data,
                    crossDomain: true,
                    success: function(response, textStatus, xhr) {
                        $('.contact-form').append('<p class="msg is-green">'+tnx+'</p>');
                        setTimeout(function(){ 
                            setCookieNclose(); 
                        }, 3000);
                    }, error: function(XMLHttpRequest, textStatus, errorThrown) {
                        $('.contact-form').append('<p class="msg is-red">'+err+'</p>');
                    }
                });

                // If customer is challenged
                if(response.status == 429) {
                    var challengeUrl = window.location.origin +'/challenge#'
                    window.location = challengeUrl
                }
            } else {
                $(this).append('<p class="msg is-red">'+mail+'</p>');
            }
            return false;
        });

        // When customer is back from challenge
        var checkURL = ["?customer_posted=true", "?contact%5Btags%5D=newsletter&form_type=customer"];
        for (var i = 0; i < checkURL.length; i++) {
            if(window.location.href.indexOf(checkURL[i]) > -1) {
                // Show newsletter box
                document.body.classList.add('newsletter-active');
                setTimeout(function(){
                    setCookieNclose(); 
                }, 5000);
            }
        }
    }
}
// Toggle Body Class
    let toggleBodyClass = function(arg) {
        document.body.classList.toggle(arg);
    }
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
function getSetVh() {
    let vh = window.innerHeight * 0.01;
    document.body.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', () => {
    getSetVh();
});

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        let elArray = document.querySelectorAll(qSelectors);
        elArray.forEach(function(e) {
            e.addEventListener("click", function() {
                toggleBodyClass(bodyClass);
            });
        });
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu');
    }
// Search
    let toggleSearch = function() { 
        toggleClass('.fire-search, .shrink-search', 'open-search');
    }
// Cart
    let toggleCart = function() {
        toggleClass('.carto, .cartc', 'open-cart');
        const clsbtn = document.querySelector('.cartc');
        if (clsbtn) {
            clsbtn.addEventListener('click', () => {
                document.body.classList.remove('hideheader');
            });
        }
    }

// Dropdown menu header
function dropdownMenu() {
    const detailsElements = document.querySelectorAll("details.lv1");

    function handleClickOnDetails() {
      // close all details
      let detailsOpened = document.querySelectorAll("details[open].lv1");

      for (const item of detailsOpened) {
        if (this != item) {
          item.removeAttribute("open");
        }
      }
    }

    detailsElements.forEach(function (item) {
      item.addEventListener("click", handleClickOnDetails);
    });
}

// Close <details> when you click outside
var details = [...document.querySelectorAll('details')];
document.addEventListener('click', function(e) { 
    if (!details.some(f => f.contains(e.target))) { 
        details.forEach(f => f.removeAttribute('open')) 
    } else { 
        details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '') 
    } 
});

// update button price on variant change 
function updatePrice(obj,idd) {
  var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
  var cid = obj.options[obj.selectedIndex].getAttribute('data-com-price');
  console.log('cid', cid)
  var pb = document.querySelector('.uprice'+idd);
  var cpb = document.querySelector('.upricedel'+idd);
  pb.innerHTML = uid;
   cpb.innerHTML = cid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd); }

$('body').on('change', '.productSelect', function() {
  var variant_link = $(this).find('option:selected').attr('data-link');
  var product_id = $(this).data('product-id');
  var primary_img = $(this).find('option:selected').data('image-primary');
  
  $('.card-' + product_id).find('a').attr('href',variant_link);
  $('.primary-' + product_id + ' picture img').attr('src', primary_img);
  $('.primary-' + product_id + ' picture img').attr('srcset', primary_img); 
  
});

$(document).on('cart.requestComplete', function(event, cart) {
        cart_gift();
    });
// AJAX cart.js
// AJAX cart init can be located in theme.liquid

function gifthideshow(){
  var elements = document.querySelectorAll('.product_handle');
  var searchText = $('.gift_form_group input[type=checkbox]').attr('data-product-handle');
  var count = 0;
  elements.forEach(function(element) {
    if (element.innerText.includes(searchText)) {
       var text_desc = $('.gift_form_group input[type=checkbox]').attr('data-desc');
      if(text_desc != ''){
        $(element).parents('.cart-desc').find('.custom-desc').remove();
        $(element).after('<div class="custom-desc">' + text_desc + '</div>');
      }
      count++;
    }else{
      $(element).parents('.cart-desc').find('.custom-desc').remove();
    }
  });
  if(count > 0 ){
    $('.gift_form_group input[type=checkbox]').prop('checked', true);
  }else{
    $('.gift_form_group input[type=checkbox]').prop('checked', false);
  }
}
function ajaxCart(obj) {
    // Show loading feedback
    obj.classList.add('loading');

    // on cart request success
    $(document).ajaxSuccess(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            // on cart request complete (just in case)
            $(document).on('cart.requestComplete', function(event, cart) {
              // console.log('cart: ',cart)
                // Update # of items in cart
              document.getElementById('counter').setAttribute('data-count', cart.item_count);
              document.querySelector('#counter span').innerHTML = cart.item_count;
              $('.gift_popup_main').removeClass('is-open');
              // $('.gift_form_group input[type=checkbox]').prop('checked', false);
              // cart_gift();
              // console.log('requestComplete');
              gifthideshow();
                // Open cart
                document.body.classList.add('open-cart');
                document.body.classList.add('hideheader');
                // Remove loading feedback
                obj.classList.remove('loading');
              const cartTitles = document.querySelectorAll('.cart span.name');

              // Loop through each element and replace &#39; with '
              cartTitles.forEach(cartTitle => {
                cartTitle.textContent = cartTitle.textContent.replace(/&#39;/g, "'");
              });
            });
        }
    });

    // on cart request error
    $(document).ajaxError(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            obj.classList.remove('loading'); // Remove loading feedback
            console.log(jqxhr.responseJSON);
            alert(jqxhr.responseJSON.description);
            event.stopImmediatePropagation();
        }
    });
}

// Update # of items in cart
$(document).on('cart.requestComplete', function(event, cart) {
  gifthideshow();
    document.getElementById('counter').setAttribute('data-count', cart.item_count);
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    dropdownMenu(); // Dropdown menu
    newsletterPopup(); // Newsletter popup
    toggleMenu(); // toggle Menu
    toggleSearch(); // toggle Search
    toggleCart(); // toggle Cart
  setTimeout(function(){
  cart_gift();  
  },2000)
  
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })


$('body').on('click','.cart-overlay',function(){
    $('body').removeClass('open-cart');
})

// nice select js
  $('.bn_nice-select').each(function() {
  var select = $(this),
      name = select.attr('name');
  select.hide();
  select.wrap('<div class="bn_nice-select-wrap"></div>');
  var parent = select.parent('.bn_nice-select-wrap');
  parent.append('<div class="bn_nice-select-wrap-wp"><ul id=' + name + '></ul></div>');
  select.find('option').each(function() {
    var option = $(this),
        value = option.attr('value'),
      value_handle = value.replace(' ','_'),
        selected = option.attr('selected'),
        var_id = option.attr('data-variant-id'),
        label = option.text();
    if (selected == 'selected') {
      $('<a href="#" class="drop" cur-filter="'+value_handle+'">' + label + '</a>').insertBefore(parent.find('.bn_nice-select-wrap-wp'));
    } 
      parent.find('.bn_nice-select-wrap-wp ul').append('<li class="'+ value_handle +'"><a href="#" id="' + value + '" selected="'+selected+'" data-variant-id="'+var_id+'">' + label + '</a></li>');
  
  });
  parent.find('a').on('click', function(e) {
    parent.toggleClass('down').find('.bn_nice-select-wrap-wp').slideToggle(300);
    e.preventDefault();
  });
  parent.find('ul a').on('click', function(e) {
    var niceOption = $(this),
    	value = niceOption.attr('id'),
        text = niceOption.text();
    select.val(value);
    parent.find('.drop').text(text).attr('cur-filter',value);
    parent.find('.drop').attr('cur-filter',value);
   
    $('#change_btn_text_by_jquery').removeClass('disabled-btn');
    e.preventDefault();
  });
});
// setTimeout(function() {
// $('.bn_nice-select-wrap-wp ul li.created-descending').trigger('click');
// },50)


$('body').on('click','.bn_nice-select-wrap-wp ul li',function(){
 var url = location.pathname; 
 var handle = $('#ajaxSection_pro').attr('data-handle');  
 var criteria = $(this).attr('class');
  var cur_u = window.location.href;
  var number = cur_u.split('page=');
 if(window.location.href.indexOf('page=')  > -1){  
   var url_path = '/collections/'+handle+'?sort_by=' + criteria;
 }else{
   var url_path = url +'?sort_by=' + criteria ;
 } 
   $.ajax({
      url: url_path,
      type:'GET',
      success: function(data) {
        var data = $(data).find('#ajaxSection_pro').html();
        history.pushState(null, null, url_path);
        $('#ajaxSection_pro').html(data);
      }
    });
  }); 


$(window).scroll(function () {
if($('.bn_facet-filters').length > 0){
      var btn = $('.bn_facet-filters').offset().top;
      var header_top = $('#header').outerHeight();
      var win = $(window).scrollTop() + header_top + 1;
      if(win >= btn) {
        $('.bn_select-main').addClass('sticky_filter').css('top',header_top+'px');
      }else{
        $('.bn_select-main').removeClass('sticky_filter').css('top','unset');
      }
    }
});

// gift cart
$('body').on('change', '.gift_form_group input[type=checkbox]', function() {
  var item_id = $(this).attr('data-product-id');
  var item_handle = $(this).attr('data-product-handle');
    if($(this).is(':checked')) {
        CartJS.addItem(item_id);
    } else {
      $('.productsInCart').each(function(i, v) {
      var product_cart = $(this).find('.product_handle');
      var product_cart_val = product_cart.text().trim();
        if(product_cart_val == item_handle){
          var data_item_index = i + 1;
           CartJS.updateItem(data_item_index,0);
        }
      });
    }
});

$('body').on('change', '.cart_label input[type=checkbox]', function() {
    if ($(this).hasClass('note_added')){
      $(this).removeClass('note_added')
      $('.cart_label_note').hide().removeClass('note_active'); 
      $('.cart_message').hide();
      $('.cart_label  input[type=checkbox]').prop('checked', false);
      $('textarea#CartSpecialNote').val('');
    }else if($(this).is(':checked')) {
      $('.cart_label_note').show().addClass('note_active'); 
    }else {
      $('.cart_label_note').hide().removeClass('note_active'); 
    }
});

$('body').on('click', '.gift_popup_overlay,.gift_popup_close', function() {
    $('.gift_popup_main').removeClass('is-open');
    var cartNote = document.getElementById('CartSpecialInstructions');
      if (cartNote.value == '' || $('#gift_contains').hasClass('note_added') == false) {
         $('.gift_form_group input[type=checkbox]').prop('checked', false);
      }
});

var delay_slide = parseInt($('.our_book_slider .swiper-wrapper').attr('data-slide-delay'));
// let delayspeed = 5;
var Swipes = new Swiper('.our_book_slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next.our_book_arrow',
      prevEl: '.swiper-button-prev.our_book_arrow',
    },
    pagination: {
      el: ".swiper-pagination.our_book_dots",
    },
    autoplay:{
      delay: delay_slide,
    }
});

$('.gift_qtyBox_inn').on('click', '.quantity__button', function(e) {
    e.preventDefault();
    var $input = $(this).siblings('.qtyBoxInput');
    var value = parseInt($input.val());
    var min = parseInt($input.attr('min')) || 1;
    var max = parseInt($input.attr('max')) || 100; // You can set a max value if needed

    if ($(this).hasClass('plus') && value < max) {
        $input.val(value + 1);
    } else if ($(this).hasClass('minus') && value > min) {
        $input.val(value - 1);
    }
});
$('body').on('click', '.gift_btns', function(e) {
    e.preventDefault();
    var val_gift = $('textarea#CartSpecialInstructions').val().trim();
    if(val_gift !== '') {
        $('.gift_message').show();
        $('#gift_contains').addClass('note_added');
        $('.cart_recent_note').text('Gift Note Received: '+ val_gift).show();
       $('.gift_form_group input[type=checkbox]').prop('checked', true);
        $('textarea#CartSpecialInstructions').hide();
        $(this).hide();
    } else {
      $('#gift_contains').removeClass('note_added');
      $('.gift_form_group input[type=checkbox]').prop('checked', false);
        $('.gift_message').hide();
        $(this).show();
      $('.cart_recent_note').text('').hide();
    }
});

$('body').on('click', '.cart_btns', function(e) {
    e.preventDefault();
    var val_gift = $('textarea#CartSpecialNote').val().trim();
    if(val_gift !== '') {
      $('.cart_message').show();
      $('#cart_contains').addClass('note_added');
      $('.cart_label input[type=checkbox]').prop('checked', true);
      $('.cart_label_note').hide();
      $(this).addClass('note_hasadd');
    } else {
      $('#cart_contains').removeClass('note_added');
      $('.cart_label input[type=checkbox]').prop('checked', false);
      $('.cart_message').hide();
      $(this).removeClass('note_hasadd');
    }
});

$('body').on('keyup', '#CartSpecialNote', function(e) {
    e.preventDefault();
    var val_gift = $(this).val().trim();
    if(val_gift !== '') {
       $('.cart_btns').addClass('note_hasadd');
      $('.cart_label_note').removeClass('note_active');
    } else {
      $('.cart_btns').removeClass('note_hasadd');
      $('#cart_contains').removeClass('note_added');
      $('.cart_message').hide();
      $('.cart_label_note').addClass('note_active');
    }
});

$('body').on('click', '.cart_message', function(e) {
    e.preventDefault();
    $('.cart_label_note').show();
});
$('body').on('click', '.gift_message', function(e) {
    // var cartNote = document.getElementById('CartSpecialInstructions');
    // if (cartNote) {
    //   cartNote.value = '';
    // }
   $(this).hide();
   $('.gift_btns').show();
  $('.cart_recent_note').hide();
   $('textarea#CartSpecialInstructions').show();
   $('.gift_form_group input[type=checkbox]').prop('checked', false);
});

if ($(window).width() < 1367) {
$("body").on("click", "#header .megamenu_new > li > a.megamenu_menu", function (e) {
    e.preventDefault();
    var $this = $(this).parent('li');
    if ($this.hasClass("is-open")) {
        $this.removeClass("is-open");
        $this.find(".new_megamenu_main").removeClass("is-open");
    } else {
        $("#header .megamenu_new>li, .new_megamenu_main").removeClass("is-open");
        $this.addClass("is-open");
        $this.find(".new_megamenu_main").addClass("is-open");
    }
});
}

function headerspace() {
    setTimeout(function() {
        var headerHeight = $('#header').outerHeight();
        var announcementbar = $('.announcement-bar').outerHeight();
        $('.main_new_menulinks').css("top", headerHeight + announcementbar);
    }, 1000);
}
headerspace();
$(window).on('resize orientationchange', function () {
    headerspace();
});


$("body").on("click", ".new_hamburger_icon", function (e) {
  e.preventDefault();
  if($(this).hasClass("is-open")){
    $(".new_hamburger_icon, .main_new_menulinks").removeClass("is-open");
    $("body").removeClass("is-open");
  }else{
    $(this).addClass("is-open");
    $(".main_new_menulinks").addClass("is-open");
    $("body").addClass("is-open");
  }
});

$("body").on("click", "#shopify-section-header header .menulink .megamenu_new>li>a.megamenu_menu", function (e) {
    if ($(window).width() < 992) {
        e.preventDefault();
        var $currentLink = $(this);
        var $submenu = $currentLink.next();
        if ($currentLink.hasClass("active")) {
            $currentLink.removeClass("active");
            $submenu.hide();
        } else {
            $("#shopify-section-header header .menulink .megamenu_new>li>a").removeClass("active");
            $(".new_megamenu_main").hide();
            $submenu.slideDown(600);
            $currentLink.addClass("active");
        }
    }
});


// custom variant drop js 

$('body').on('click','.custom-card-variant-drop li:not([disabled])',function(e){
    e.preventDefault();
    let value = $(this).attr('data-value');
    let form = $(this).closest('form');
    form.find('select').val(value).trigger('change');
    form.find('.custom-variant-drop-wrp .active-text-img').html($(this).html());
    form.find('.custom-card-variant-drop li').removeClass('active');
    $(this).addClass('active');
});


$('body').on('click','.custom-variant-drop-wrp .active-value, .custom-variant-drop-wrp ul li:not([disabled])',function(e){
    e.preventDefault();
    $(this).closest('.custom-variant-drop-wrp').toggleClass('active');
    $(this).closest('form').find('.custom-card-variant-drop').slideToggle();
});


let PDPSwiper = null;

// function handleSwiper() {
//   const isDesktop = window.innerWidth >= 778;
//   const carouselOuter = document.querySelector('.product-image-carousel'); 

//   // Always destroy first (if exists)
//   if (PDPSwiper) {
//     PDPSwiper.destroy(true, true);
//     PDPSwiper = null;
//   }
  
//   // Then init only for desktop
//   if (isDesktop || carouselOuter.classList.contains('scroll-snap')) {
//     PDPSwiper = new Swiper('.product-image-carousel-swiper', {
//       loop: true,
//       slidesPerView: 1,
//       spaceBetween: 10,
//       navigation: {
//         nextEl: '.swiper-button-next.product_arrow',
//         prevEl: '.swiper-button-prev.product_arrow',
//       },
//       pagination: {
//         el: ".swiper-pagination.product_dots",
//       }
//     });
//   }
// }


function handleSwiper() {
  PDPSwiper = new Swiper('.product-image-carousel-swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next.product_arrow',
      prevEl: '.swiper-button-prev.product_arrow',
    },
    pagination: {
      el: ".swiper-pagination.product_dots",
    }
  }); 
}

// Initial run
handleSwiper();

// Resize
window.addEventListener('resize', handleSwiper);